// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"122":"bc9539013b2aeda4","329":"62fc9084b146839e","454":"0ba7bc1ec89fffb0","540":"1f3f55d83891d55d","618":"e5e36f81bafae0d8","621":"73a728c2e0f4e264","652":"906b4eff59235a8f","950":"373b560a96b02d88"}[chunkId] + ".js";
};